export default __webpack_public_path__ + "static/hw_dht11-a6421aac326c19b190a4c625081e084e.jpg";